export enum ActivityStatus {
  WORKING = 'WORKING',
  STOPPED = 'STOPPED',
  IDLING = 'IDLING',
  UNKNOWN = 'UNKNOWN',
}
